import { custodial } from '@/utils/extras'
import { CID } from 'multiformats/cid'

export const shortenAddress = (account: string | undefined): string => {
    if (!account) {
        return ''
    }
    if (account === custodial) {
        return 'No Owner'
    }
    if (!account.includes('0x')) {
        return account
    }
    return account?.slice(0, 6) + account?.slice(-4)
}

export const shortestAddress = (account: string): string => {
    return account?.slice(2, 4) + account?.slice(-4)
}

export const shortAddress = (account: string): string => {
    return account?.slice(2, 6) + account?.slice(-4)
}

export const shortenUrl = (account: string): string => {
    return account?.slice(0, 20) + '...'
}

export const cidv1FromCidv0Url = (url: string) => {
    if (url.startsWith('ipfs://')) {
        const cidV0String = url.split('ipfs://')[1]
        const cidV0 = CID.parse(cidV0String)
        const cidV1 = cidV0.toV1().toString()
        return 'https://' + cidV1 + '.ipfs.dweb.link/'
    }
    return ''
}

export const urlFromAddress = (address: string) => {
    return 'https://scan.v4.testnet.pulsechain.com/#/address/' + address + '?tab=tokens'
}
